import React, { useState } from "react"
import Slider from "react-slick"
import { Link } from "gatsby"
import { ReactComponent as Arrow } from "@svgs/arrow.svg"

const Subnav = ({ items, activeSlug }) => {
  const [isOpen, setIsOpen] = useState(false)

  const ArrowButton = ({ onClick, rotate, className, ariaLabel }) => {
    const classNamesArray = className.split(" ")
    const isDisabled = classNamesArray.includes("slick-disabled")
    const arrowClasses = `ml-2 arrow ${rotate ? "rotate-180 " : ""}${
      isDisabled ? "fill-[#C7C7C7]" : "fill-green-primary"
    }`

    return (
      <button
        className={`w-[87px] flex justify-center items-center px-4`}
        onClick={onClick}
        disabled={isDisabled}
        aria-label={ariaLabel}
      >
        <Arrow className={arrowClasses} />
      </button>
    )
  }

  const slidesToShow = items.length > 7 ? 7 : items.length

  const breakpoints = [
    { breakpoint: 1280, slidesToShow: 6 },
    { breakpoint: 1024, slidesToShow: 5 },
    { breakpoint: 769, slidesToShow: 4 },
    { breakpoint: 600, slidesToShow: 2 },
    { breakpoint: 380, slidesToShow: 1 },
  ]

  const responsive = breakpoints.map(({ breakpoint, slidesToShow }) => {
    return {
      breakpoint,
      settings: {
        slidesToShow,
        nextArrow:
          items.length > slidesToShow ? <ArrowButton rotate={false} ariaLabel="Next Button" /> : null,
        prevArrow:
          items.length > slidesToShow ? <ArrowButton rotate={true} ariaLabel="Previous Button" /> : null,
        className: items.length > slidesToShow ? "flex justify-between" : "",
      },
    }
  })

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow,
    nextArrow: <ArrowButton rotate={false} ariaLabel="Next Button" />,
    prevArrow: <ArrowButton rotate={true} ariaLabel="Previous Button" />,
    className: items.length > slidesToShow ? "flex justify-between" : "",
    responsive,
  }

  return (
    <nav className="w-full">
      <div className="flex flex-col justify-center overflow-hidden">
        <div className="border-1 border-gray rounded-xl bg-white">
          <Slider {...settings}>
            {items.map(item => (
              <Link
                key={item.key}
                to={item.url}
                onClick={() => setIsOpen(!isOpen)}
                className={`flex justify-center rounded-xl items-center h-[60px] px-2.5 text-2xl cursor-pointer ${
                  item.slug === activeSlug || item.slug?.current === activeSlug
                    ? "bg-sage"
                    : "hover:pl-2.5 hover:text-green-primary"
                }`}
                aria-label={item.title}
              >
                <div className="w-full h-full flex justify-center items-center">
                  <h3
                    className={`text-base w-[124px] text-center font-medium whitespace-wrap sm:whitespace-nowrap ${
                      item.slug === activeSlug ||
                      item.slug?.current === activeSlug
                        ? "text-green-primary"
                        : ""
                    }`}
                  >
                    {item.title}
                  </h3>
                </div>
              </Link>
            ))}
          </Slider>
        </div>
      </div>
    </nav>
  )
}

export default Subnav
